import { render, staticRenderFns } from "./CreateNCF.vue?vue&type=template&id=9ba2fb90&scoped=true&"
import script from "./CreateNCF.vue?vue&type=script&lang=js&"
export * from "./CreateNCF.vue?vue&type=script&lang=js&"
import style0 from "./CreateNCF.vue?vue&type=style&index=0&id=9ba2fb90&prod&lang=scss&scoped=true&"
import style1 from "./CreateNCF.vue?vue&type=style&index=1&id=9ba2fb90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ba2fb90",
  null
  
)

export default component.exports